import { ReactNode } from 'react';

import { Header } from '@/features/header';
import { MainSidebar } from '@/features/sidebar';
import { cn } from '@/utils/styles';
import { useAlwaysScrollTop } from '../../hooks/use-always-scroll-top';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';

export type AppLayoutProps = {
  readonly children: ReactNode;
};

export function AppLayout({ children }: AppLayoutProps) {
  useAlwaysScrollTop();

  return (
    <SidebarProvider className="flex h-svh w-full overflow-hidden">
      <MainSidebar />
      <SidebarInset>
        <Header />
        <div id="app-scroll" className={cn('bg-neutral-25 min-h-0 flex-1 overflow-auto [scrollbar-gutter:stable]')}>
          {children}
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
